function config($stateProvider) {
    // set default parent states
    $stateProvider
        .state('pages.main', {
            views: {
                "": {
                    template: require('../views/main/page.html'),
                    controllerAs: 'page'
                },
                "header": {
                    template: require('../views/main/header.html'),
                    controller: 'HeaderController',
                    controllerAs: 'header'
                },
                "sidebar": {
                    template: require('../views/main/sidebar.html'),
                    controller: 'sidebarController',
                    controllerAs: 'sidebar'
                }
            },
        })
    // add individual page groups
    require('./anomalies')($stateProvider);
    require('./applications')($stateProvider);
    require('./archive')($stateProvider);
    require('./files')($stateProvider);
    require('./feed')($stateProvider);
    require('./general_network')($stateProvider);
    require('./ioc_notifications')($stateProvider);
    require('./search')($stateProvider);
    require('./stealth')($stateProvider);
    require('./system_events')($stateProvider);
    require('./user')($stateProvider);
    require('./hunting')($stateProvider);
    //require('./hybrid_alerts')($stateProvider);
}

config.$inject = ['$stateProvider'];
module.exports = config;


/** WEBPACK FOOTER **
 ** ./src/pages/routes/index.js
 **/